import { render } from "./PivotItem.vue?vue&type=template&id=39feda71"
import script from "./PivotItem.vue?vue&type=script&lang=js"
export * from "./PivotItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__